import { styled } from '@linaria/react';

export const OffersMobileContainer = styled.div`
  display: grid;
  grid-template-columns: 80px 80px 1fr;
  column-gap: 20px;
  align-content: center;

  width: 100%;
  height: 35px;
  margin: 10px 0;
  padding: 0 15px;

  @media (max-width: 420px) {
    column-gap: 10px;
  }

  @media (max-width: 360px) {
    grid-template-columns: 80px 1fr;
  }
`;

export const SignupOfferWrapper = styled.div`
  grid-column: 2;
  align-self: center;
`;

// SpecialOfferWrapper removed with Special column

export const OfferAmount = styled.p`
  font-style: normal;
  font-weight: 800;
  font-size: 14px;
  line-height: 16px;
  color: var(--ogm-grid-offer-color);
`;

export const SeeOffersBtn = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  grid-column: -2;
  justify-self: end;
  padding: 5px 8px 6px;
  background: var(--ogm-active-tab-bg-color);
  font-family: var(--ogm-font-family-2);
  font-weight: 600;
  color: var(--ogm-timberwolves);
  border-radius: 5px;
  white-space: nowrap;
  max-width: 150px;
`;
